<template>
  <dash-board-layout :active="3" :title="true">
    <div class="row">
      <div class="col-xl-5 col-lg-6 col-md-12">
        <div class="card acc_balance">
          <div class="card-header">
            <h4 class="card-title">Wallet</h4>
          </div>
          <div class="card-body">
            <el-table
              :data="parent_balances"
              highlight-current-row
              @current-change="handleCurrentChange"
            >
              <el-table-column label="symbol" width="80">
                <template slot-scope="scope">
                  <span>
                    {{ scope.row.display_name }}
                  </span>
                </template>
              </el-table-column>

              <!-- <el-table-column label="sum amount" header-align="right">
                <template slot-scope="scope">
                  <span
                    style="float: right"
                    :title="formatNum(scope.row.sum_amount, 8)"
                  >
                    {{ formatNum(scope.row.sum_amount, 4) }}
                  </span>
                </template>
              </el-table-column> -->
              <el-table-column label="available" header-align="right">
                <template slot-scope="scope">
                  <!-- <i class="el-icon-time"></i> -->
                  <span
                    style="float: right"
                    :title="
                      $number_format(scope.row.available, 8, '.', ',', 'floor')
                    "
                  >
                    {{
                      $number_format(scope.row.available, 4, ".", ",", "floor")
                    }}
                    <!-- {{ formatNum(scope.row.available, 4) }} -->
                  </span>
                </template>
              </el-table-column>
              <el-table-column
                fixed="right"
                label=""
                align="right"
                width="240"
                header-align="right"
              >
                <template slot-scope="scope">
                  <span v-if="scope.row.symbol != 'USD'" style="cursor: pointer"
                    ><i
                      @click="buyCoinClick(scope.row)"
                      class="el-icon-bank-card"
                      >Buy</i
                    ></span
                  >
                  &nbsp;
                  <span style="color: green; cursor: pointer"
                    ><i
                      @click="depositClick(scope.row)"
                      class="el-icon-download"
                      >Deposit</i
                    ></span
                  >
                  &nbsp;
                  <span style="color: red; cursor: pointer"
                    ><i
                      @click="withdrawClick(scope.row)"
                      class="el-icon-upload2"
                      >Withdraw</i
                    ></span
                  >
                </template>
              </el-table-column>
            </el-table>

            <!-- <span>Available USDC</span>
            <h3>{{ usdVal }} USDC</h3> -->

            <div class="d-flex justify-content-between my-4">
              <!-- <div>
                <p class="mb-1">Buy this month</p>
                <h4>3.0215485 BTC</h4>
              </div>
              <div>
                <p class="mb-1">Sell this month</p>
                <h4>3.0215485 BTC</h4>
              </div> -->
            </div>

            <!-- <div class="btn-group mb-3">
              <button class="btn btn-primary">Sell</button>
              <button class="btn btn-success">Buy</button>
            </div> -->
          </div>
        </div>
      </div>

      <div
        class="col-xl-7 col-lg-6 col-md-12"
        v-if="opType == 'deposit' && selectSymbol.symbol == 'USD'"
      >
        <div class="card">
          <div class="card-header">
            <h4 class="card-title">Transfer (Deposit USD)</h4>
          </div>
          <div class="card-body" style="text-align: center" v-if="selectSymbol">
            <div class="cpay-Recharge-connect" v-if="!curLoginUser.certStatus">
              <div class="cpay-Recharge-address"></div>
              <div class="cpay-Recharge-msg" style="text-align: left">
                <p>Your KYC information is temporarily unavailable</p>
              </div>
            </div>
            <div class="cpay-Recharge-connect" v-if="curLoginUser.certStatus">
              <div class="cpay-Recharge-address"></div>
              <div v-html="decodeURIComponent(curLoginUser.LBDInfo)"></div>
            </div>
          </div>

          <!-- <div class="cpay-Recharge-msg" style="text-align: left">
            <p>Collection information</p>
            <p></p>
            <p>
              Account Name： Legend Trading Inc
              <span
                class="tag-read"
                data-clipboard-text="Legend Trading Inc"
                style="color: blue; float: right"
                @click="copy"
                >copy</span
              >
            </p>

            <p>
              Account Address： 960 San Antonio Road, Suite 200, Palo Alto, CA
              94303, United States
              <span
                class="tag-read"
                data-clipboard-text="960 San Antonio Road, Suite 200, Palo Alto,CA 94303, United States"
                style="color: blue; float: right"
                @click="copy"
                >copy</span
              >
            </p>

            <p>
              Account Number： 1503983881
              <span
                class="tag-read"
                data-clipboard-text="1503983881"
                style="color: blue; float: right"
                @click="copy"
                >copy</span
              >
            </p>

            <p>
              Bank Name： Signature Bank
              <span
                class="tag-read"
                data-clipboard-text="Signature Bank"
                style="color: blue; float: right"
                @click="copy"
                >copy</span
              >
            </p>

            <p>
              Bank address： 565 Fifth Avenue New York NY 10017, USA
              <span
                class="tag-read"
                data-clipboard-text="565 Fifth Avenue New York NY 10017, USA"
                style="color: blue; float: right"
                @click="copy"
                >copy</span
              >
            </p>

            <p>
              SWIFT code： SIGNUS33XXX
              <span
                class="tag-read"
                data-clipboard-text="SIGNUS33XXX"
                style="color: blue; float: right"
                @click="copy"
                >copy</span
              >
            </p>

            <p>
              Bank country： United States
              <span
                class="tag-read"
                data-clipboard-text="United States"
                style="color: blue; float: right"
                @click="copy"
                >copy</span
              >
            </p>
          </div> -->
        </div>
      </div>

      <div
        class="col-xl-7 col-lg-6 col-md-12"
        v-if="opType == 'deposit' && selectSymbol.symbol != 'USD'"
      >
        <div class="card">
          <div class="card-header">
            <h4 class="card-title">Deposit</h4>
          </div>
          <div class="card-body" style="text-align: center" v-if="selectSymbol">
            <el-radio-group
              v-model="tabPosition"
              style="margin-bottom: 30px"
              v-if="child_chains.length > 1"
            >
              <el-radio-button
                :value="item.chain_id"
                v-for="(item, index) in child_chains"
                :key="index"
                :label="item.chain_id"
                >{{ item.name }}</el-radio-button
              >
              <!-- <el-radio-button label="TRC20">TRC-20</el-radio-button> -->
            </el-radio-group>

            <div class="cpay-Recharge-connect">
              <div class="cpay-Recharge-address">
                <p style="margin-bottom: 1rem; line-height: 1.5rem">
                  Address:{{ addressInfo.address }}
                  <span
                    class="tag-read"
                    :data-clipboard-text="addressInfo.address"
                    style="color: blue"
                    @click="copy"
                    >copy</span
                  >
                </p>
                <p style="text-align: center">
                  <img
                    style="width: 150px; height: 150px; object-fit: contain"
                    :src="`data:image/png;base64,${addressInfo.qrcode}`"
                  />
                  <!-- v-lazy="`data:image/png;base64,${qrcode && qrcode}`" -->
                </p>
              </div>
              <div class="cpay-Recharge-msg" style="text-align: left">
                <p>Prop</p>
                <p>
                  1, the minimum deposit amount is
                  {{ formatNum(selectSymbol.withdrawMin, 4) }}
                  {{ selectSymbol.display_name }}
                </p>

                <p>
                  2, the estimated arrival time is 10-60 minutes, if you need to
                  quickly arrive, you can pay the appropriate miners' fees to
                  the {{ selectSymbol.display_name }} network
                </p>

                <p>
                  3, your address will not change for no reason, can be repeated
                  coin
                </p>

                <p>
                  4, be sure to confirm the security of computers and browsers
                  to prevent information from being tampered with or disclosed
                </p>

                <p>
                  If you have any questions, please contact customer service
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        class="col-xl-7 col-lg-6 col-md-12"
        v-if="opType == 'withdraw' && selectSymbol.symbol != 'USD'"
      >
        <div class="card">
          <div class="card-header">
            <h4 class="card-title">Withdraw</h4>
          </div>
          <div class="card-body" style="text-align: center" v-if="selectSymbol">
            <el-radio-group
              v-model="tabPosition"
              style="margin-bottom: 30px"
              v-if="child_chains.length > 1"
            >
              <el-radio-button
                :value="item.chain_id"
                v-for="(item, index) in child_chains"
                :key="index"
                :label="item.chain_id"
                >{{ item.name }}</el-radio-button
              >
              <!-- <el-radio-button label="TRC20">TRC-20</el-radio-button> -->
            </el-radio-group>

            <el-form label-position="top" style="text-align: left">
              <!--<vue-simple-suggest
                  v-model="chosen"
                  :list="simplelist"
                  :filter-by-query="true"
                >
             
                </vue-simple-suggest> -->
              <div class="form-group col-xl-12">
                <label class="mr-sm-2">Address</label>
                <div>
                  <el-input
                    class="vs-adress-ipt"
                    label="address"
                    placeholder="Please enter the withdrawal address"
                    v-model="form.address"
                  />
                </div>
                <!-- v-on:blur="OMNIblur()"
                v-on:focus="OMNIfocus('OMNI')"
                    v-on:input="OMNIchange()" -->

                <div
                  class="parentadresslist"
                  v-if="adresslistflag && history_addresslist.length > 0"
                >
                  <!--  <p style="margin-top:10px">历史提币地址</p>
                      <p v-if="history_addresslist.length<=0">无<p>-->
                  <p
                    v-for="(item, index) in history_addresslist"
                    v-bind:key="index"
                    @click="clickhistory(item.address)"
                  >
                    {{ item.address }}
                  </p>
                </div>
              </div>

              <div class="form-group col-xl-12">
                <label class="mr-sm-2">Amount</label>
                <label style="float: right"
                  >Fee
                  {{
                    formatNum(
                      selectSymbol.withdrawFee,
                      selectSymbol.legal_currency_decimal_places
                    )
                  }}
                  {{ selectSymbol.withdrawFee_symbol }}</label
                >
                <el-input
                  size="large"
                  v-model="form.count"
                  :placeholder="`The maximum can be withdrawn ${formatNum(
                    selectSymbol.available,
                    4
                  )}`"
                >
                  <span slot="append">{{ selectSymbol.display_name }}</span>
                </el-input>
              </div>

              <div class="form-group col-xl-12">
                <label class="mr-sm-2">Actual amount received</label>
                <el-input
                  size="large"
                  :value="form.count - selectSymbol.withdrawFee || 0"
                  disabled
                  placeholder="Input"
                >
                  <span slot="append">{{
                    selectSymbol.withdrawFee_symbol
                  }}</span>
                </el-input>
              </div>

              <!--  <Form-item label="OMNI地址" v-if="protocol=='OMNI'">
                    <el-input
                      size="large"
                      v-model="form.address"
                      v-verify="form.address"
                      
                      placeholder="请输入OMNI提币地址"
                    ></el-input>
                    <label class="error"  v-on:focus="OMNIblur()" v-remind="form.address"></label>
                  </Form-item>
                  
                  <Form-item label="ERC-20地址" v-if="protocol!='OMNI'">
                    <el-input
                      size="large"
                      v-model="form.address"
                      v-verify="form.address"
                      
                      placeholder="请输入ERC-20提币地址"
                    ></el-input>
                    <label class="error" v-remind="form.address"></label>
                  </Form-item> -->
              <!-- <el-select
                    class="selectExample"
                    label="选择历史提币地址"
                    v-model="select1"
                    >
                    <el-select-item :key="index" :value="item.value" :text="item.text" v-for="item,index in options1" />
                  <</el-select>-->
              <label class="error" v-remind="form.count"></label>
              <div class="vx-row">
                <div class="vx-col sm:w-1/2 w-full mb-2"></div>
              </div>

              <div class="form-group col-xl-12">
                <!-- <el-button size="large" type="primary" @click="submitWithdraw"
                    >Submit</el-button
                  > -->
                <button
                  type="button"
                  class="btn btn-primary btn-block"
                  @click="withdraw"
                >
                  Withdraw Now
                </button>
              </div>
            </el-form>
          </div>
        </div>
      </div>

      <div
        class="col-xl-7 col-lg-6 col-md-12"
        v-if="opType == 'withdraw' && selectSymbol.display_name == 'USD'"
      >
        <div class="card">
          <div class="card-header">
            <h4 class="card-title">Withdraw</h4>
          </div>
          <div class="card-body">
            <form action="" @submit.prevent="">
              <div class="form-group">
                <div class="input-group mb-3">
                  <div class="input-group-prepend">
                    <label class="input-group-text"
                      ><i class="fa fa-money"></i
                    ></label>
                  </div>
                  <input
                    type="text"
                    class="form-control"
                    v-model="withdrawVal"
                    :placeholder="`eg:1000 USD`"
                  />
                </div>
              </div>
              <div class="form-group">
                <div class="input-group mb-3">
                  <div class="input-group-prepend">
                    <label class="input-group-text"
                      ><i class="fa fa-bank"></i
                    ></label>
                  </div>
                  <select class="form-control" v-model="selectCard">
                    <option
                      :value="item.id"
                      v-for="(item, index) in data"
                      :key="index"
                    >
                      {{ item.cardName }} {{ item.typeName }}
                      {{ item.account_no }}
                    </option>
                  </select>
                </div>
              </div>

              <button class="btn btn-primary btn-block" @click="withdraw">
                Withdraw Now
              </button>
            </form>
          </div>
        </div>
      </div>
      <div class="col-xl-5 col-lg-6 col-md-12" v-if="false">
        <div class="card profile_card">
          <div class="card-body">
            <div class="media">
              <img
                class="mr-3 rounded-circle mr-0 mr-sm-3"
                :src="
                  curLoginUser.avatar
                    ? curLoginUser.avatar
                    : '../../assets/images/profile/2.png'
                "
                width="60"
                height="60"
                alt=""
              />
              <div class="media-body">
                <span>Hello</span>
                <h4 class="mb-2">{{ curLoginUser.realName }}</h4>
                <p class="mb-1" v-if="curLoginUser.mobile">
                  <span><i class="fa fa-phone mr-2 text-primary"></i></span>
                  {{ curLoginUser.mobile }}
                </p>
                <p class="mb-1">
                  <span><i class="fa fa-envelope mr-2 text-primary"></i></span>
                  {{ curLoginUser.email }}
                </p>
              </div>
            </div>

            <ul class="card-profile__info">
              <li>
                <h5 class="mr-4">Address</h5>
                <span class="text-muted"
                  >{{ curLoginUser.address }}, {{ curLoginUser.city }},
                  {{ curLoginUser.country }}</span
                >
              </li>
              <!-- <li class="mb-1">
                <h5 class="mr-4">Total Log</h5>
                <span>103 Time (Today 5 Times)</span>
              </li>
              <li>
                <h5 class="text-danger mr-4">Last Log</h5>
                <span class="text-danger">3 February, 2020, 10:00 PM</span>
              </li> -->
            </ul>
            <!-- <div class="social-icons">
              <a class="facebook text-center" href="javascript:void(0)"
                ><span><i class="fa fa-facebook"></i></span
              ></a>
              <a class="twitter text-center" href="javascript:void(0)"
                ><span><i class="fa fa-twitter"></i></span
              ></a>
              <a class="youtube text-center" href="javascript:void(0)"
                ><span><i class="fa fa-youtube"></i></span
              ></a>
              <a class="googlePlus text-center" href="javascript:void(0)"
                ><span><i class="fa fa-google"></i></span
              ></a>
            </div> -->
          </div>
        </div>
      </div>
    </div>
    <div class="row" v-if="false">
      <div class="col-xl-12">
        <div class="card">
          <div class="card-header border-0">
            <h4 class="card-title">All Activities</h4>
          </div>
          <div class="card-body pt-0">
            <div class="transaction-table">
              <div class="table-responsive">
                <table class="table mb-0 table-responsive-sm">
                  <tbody>
                    <tr>
                      <td>
                        <span class="sold-thumb"
                          ><i class="la la-arrow-down"></i
                        ></span>
                      </td>

                      <td>
                        <span class="badge badge-danger">Sold</span>
                      </td>
                      <td><i class="cc BTC"></i> BTC</td>
                      <td>Using - Bank *******5264</td>
                      <td class="text-danger">-0.000242 BTC</td>
                      <td>-0.125 USD</td>
                    </tr>
                    <tr>
                      <td>
                        <span class="buy-thumb"
                          ><i class="la la-arrow-up"></i
                        ></span>
                      </td>
                      <td>
                        <span class="badge badge-success">Buy</span>
                      </td>
                      <td><i class="cc LTC"></i> LTC</td>
                      <td>Using - Card *******8475</td>
                      <td class="text-success">-0.000242 BTC</td>
                      <td>-0.125 USD</td>
                    </tr>
                    <tr>
                      <td>
                        <span class="sold-thumb"
                          ><i class="la la-arrow-down"></i
                        ></span>
                      </td>
                      <td>
                        <span class="badge badge-danger">Sold</span>
                      </td>
                      <td><i class="cc XRP"></i> XRP</td>
                      <td>Using - Card *******8475</td>
                      <td class="text-danger">-0.000242 BTC</td>
                      <td>-0.125 USD</td>
                    </tr>
                    <tr>
                      <td>
                        <span class="buy-thumb"
                          ><i class="la la-arrow-up"></i
                        ></span>
                      </td>
                      <td>
                        <span class="badge badge-success">Buy</span>
                      </td>
                      <td><i class="cc DASH"></i> DASH</td>
                      <td>Using - Card *******2321</td>
                      <td class="text-success">-0.000242 BTC</td>
                      <td>-0.125 USD</td>
                    </tr>
                    <tr>
                      <td>
                        <span class="sold-thumb"
                          ><i class="la la-arrow-down"></i
                        ></span>
                      </td>
                      <td>
                        <span class="badge badge-danger">Sold</span>
                      </td>
                      <td><i class="cc BTC"></i> BTC</td>
                      <td>Using - Card *******2321</td>
                      <td class="text-danger">-0.000242 BTC</td>
                      <td>-0.125 USD</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <veriForm
      :useGoogle="true"
      :useEmail="true"
      :visible="approvalValiDialog"
      :methodType="'approval'"
      v-on:onsubmit="valiForm_callback_approval"
      v-on:hideValiDialog="valiForm_callback_hide_approval"
    ></veriForm>
  </dash-board-layout>
</template>
<script>
import DashBoardLayout from "../../components/layouts/DashBoardLayout.vue";
import veriForm from "../../components/uupay/validateModal";
import { enable_bank_list } from "../../plugins/api/user_bank_acc";
import { withdrawUSDC } from "../../plugins/api/order";
import { withdraw } from "../../plugins/api/wallet";
import { Loading } from "element-ui";
import { amountinfo, amountlistinfo } from "../../plugins/api/amount";
import { getUsdtAddress, getCreditBuyCoinUrl } from "@/plugins/api/wallet";
import { mul, div, formatNumber } from "../../plugins/operation";
import store from "@/store/index";
import Clipboard from "clipboard";
export default {
  data() {
    return {
      address: "",
      qrcode: "",
      isactive: true,
      show: false,
      amount: {},
      curLoginUser: {},
      loadingInstance: {},
      addressInfo: {
        address: "",
        symbol: "",
        qrcode: "",
      },
      selectCard: "",
      data: [],
      withdrawVal: "",
      opType: "deposit",
      approvalValiDialog: false,
      balances: [],
      child_chains: [],
      parent_balances: [],
      selectSymbol: { symbol: "USD" },
      currentRow: null,
      tabPosition: null,
      form: {},
      adresslistflag: false,
      history_addresslist: [],
    };
  },
  methods: {
    copy() {
      var clipboard = new Clipboard(".tag-read");
      clipboard.on("success", (e) => {
        //           console.log('复制成功')
        this.$Message.success("Copied"); // 释放内存
        clipboard.destroy();
      });
      clipboard.on("error", (e) => {
        // 不支持复制
        this.$Message.error("error"); // 释放内存
        //           console.log('该浏览器不支持自动复制')
        clipboard.destroy();
      });
    },
    tabactive(act) {},
    buyCoinClick(item) {
      this.loadingInstance = Loading.service({ fullscreen: true });
      getCreditBuyCoinUrl({ symbol: item.symbol }).then((res) => {
        if (res.code == 0) {
          window.open(res.data.pay_url);
        } else {
          this.$Message.error(res.msg);
        }
        this.loadingInstance.close();
      });
    },
    depositClick(item) {
      this.selectSymbol = item;
      this.opType = "deposit";
      let that = this;
      this.child_chains = this.balances.filter((_itm) => {
        return _itm.parent_chain == item.chain_id;
      });
      if (this.selectSymbol.symbol != "USD") {
        getUsdtAddress({ symbol: this.selectSymbol.symbol }).then((res) => {
          console.log(res.qrcode);
          if (res.code == 0) {
            this.addressInfo = res.data;
          } else {
            this.$Message.error(res.msg);
          }
        });
      }
    },
    withdrawClick(item) {
      this.opType = "withdraw";
      this.selectSymbol = item;
      this.child_chains = this.balances.filter((_itm) => {
        return _itm.parent_chain == item.chain_id;
      });
    },
    submitWithdraw() {
      return false;
    },
    formatNum(num1, length, sp) {
      return formatNumber(num1, length, sp);
    },
    valiForm_callback_approval(data) {
      if (this.selectSymbol.is_legal) {
        withdrawUSDC({
          data: {
            symbol: "USD",
            cardid: this.selectCard,
            count: this.form.count,
          },
          validata: data,
        }).then((res) => {
          if (res.code == 0) {
            this.$Message.success(res.msg);
            this.approvalValiDialog = false;
            this.selectCard = "";
            this.form.count = "";
            this.reload();
          } else {
            this.$Message.error(res.msg);
          }
          this.valiForm_callback_hide_approval();
        });
      } else {
        this.modal_loading = true;
        let subSymbol = this.selectSymbol.symbol;
        withdraw({
          data: {
            value: this.form.count,
            address: this.form.address,
            symbol: subSymbol,
          },
          validata: {
            googleCode: data.googleCode,
            emailCode: data.emailCode,
          },
        })
          .then((res) => {
            console.log(res);
            if (res.code == 0) {
              this.form.count = "";
              this.form.address = "";
              this.approvalValiDialog = false;
              this.$Notice.success({
                title: "The withdrawal application was successful",
              });
              this.getdata();
            } else {
              this.$Notice.error({
                title: res.msg,
              });
            }
          })
          .catch((error) => {
            // this.modal_loading = false;
          });
      }
      return false;
    },
    valiForm_callback_hide_approval() {
      this.approvalValiDialog = false;
    },
    withdraw() {
      if (this.form.count > parseFloat(this.selectSymbol.withdrawMin)) {
        this.approvalValiDialog = true;
      } else {
        this.$Message.warning(
          `Minimum withdrawals must not be less than ${this.selectSymbol.withdrawMin} ${this.selectSymbol.symbol}`
        );
      }
      return false;
    },
    getdata() {
      // amountlistinfo().then((res) => {
      //   console.log(res);
      // });

      enable_bank_list().then((res) => {
        if (res.code == 0) {
          res.data.forEach((item) => {
            item.typeName = "Credit Card";
            item.cardName = "";
            switch (item.account_type) {
              case "mastercard":
                item.cardName = "Master";
                break;
              case "visa":
                item.cardName = "Visa";
                break;
              case "ae":
                item.cardName = "American Express";
                break;
              case "unionpay":
                item.cardName = "Union";
                item.typeName = "Debit Card";
                break;
            }
            return item;
          });
          // console.log(cardlist);
          this.data = res.data;
        }
      });
    },
    handleCurrentChange(val) {
      this.currentRow = val;
    },
  },
  components: { DashBoardLayout, veriForm: veriForm },
  watch: {
    tabPosition: function (val, old) {
      let that = this;
      if (val != old) {
        this.selectSymbol = this.balances.filter((_itm) => {
          return _itm.chain_id == val;
        });
        if (this.selectSymbol.length == 1) {
          this.selectSymbol = this.selectSymbol[0];
        }

        getUsdtAddress({ symbol: this.selectSymbol.symbol }).then((res) => {
          if (res.code == 0) {
            this.addressInfo = res.data;
            // this.addressInfo.qrcode = res.qrcode;
            // this.addressInfo.address = res.address;
          } else {
            this.$Message.error(res.msg);
          }
          console.log(this.addressInfo);
        });
      }
    },
  },
  computed: {
    usdVal: function () {
      return this.$store.state.usdVal;
    },
    btcVal: function () {
      return this.$store.state.btcVal;
    },
  },
  mounted() {
    this.getdata();
    this.curLoginUser = this.$store.getters.curLoginUser;
    // this.balances = this.$store.getters.balanceList;
    // if (this.balances.length == 0) {
    // }
    amountlistinfo().then((data) => {
      this.balances = data;
      this.parent_balances = data.filter((itm) => {
        return itm.parent_chain == 0;
      });
    });
    // .forEach((item) => {
    //   item.sum_amount = formatNumber(item.sum_amount, 4);
    //   return item;
    // });
  },
  created() {},
};
</script>